import e from "./TypesenseSearch.vue2.js";
import "./TypesenseSearch.vue3.js";
import o from "../../_virtual/_plugin-vue_export-helper.js";
const p = /* @__PURE__ */ o(e, [["__scopeId", "data-v-9ecef7a2"]]);
export {
  p as default
};
